export default __webpack_public_path__ + "static/media/scan_car_doc.e2bb035e.svg";